<template>
    <div>
        <div class="form-group row">
            <div class="col-sm-3">
                <b-form-input
                    v-model="informationTab.title_field"
                    :disabled="isDisabled"
                    :class="`${isDisabled ? 'disabled_cursor' : ''}`"
                ></b-form-input>
            </div>
            <div class="col-sm-9">
                <div v-if="isPreview || isDisabled" class="box--text__disabled" v-html="informationTab.content_tab"></div>
                <Editor
                    v-else
                    :id="`text-dynamic-${idContent}-${indexValid}`"
                    :model.sync="informationTab.content_tab"
                    :configError.sync="dynamicConfig.content_tab"
                    :configInit="{
                        disabled: isDisabled,
                        is_autoresize_on: true
                    }"
                    @blur="handleValidateField(informationTab.content_tab, dynamicConfig.content_tab)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Editor from '@/components/Editor/main.vue';

import { validateField } from '@/utils/validate_v2';

export default {
    name: 'TabContentDynamic',
    components: {
        Editor
    },
    props: {
        idContent: {
            type: [String, Number],
            default: null
        },
        informationTab: {
            type: Object,
            default: () => ({})
        },
        dynamicConfig: {
            type: Object,
            default: () => ({})
        },
        isDisabled: {
            type: Boolean,
            default: () => false
        },
        isPreview: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            indexValid: 0
        };
    },
    methods: {
        handleValidateField(valueField, configField) {
            validateField(valueField, configField);
            this.indexValid++;
        }
    }
};
</script>
